import { gql } from '@apollo/client'

export const SHIPPING_FRAGMENT = gql`
  fragment Shipping on Shipping {
    id
    consumablesPerCase
    productsPerCase
  }
`
